import React from "react";
import WatchlistToggle from "./WatchlistToggle";
import Sparkline from "./Sparkline";
import {
  formatPrice,
  formatCompact,
  formatPercent,
  percentClass,
} from "../utils/format";

/**
 * F7 — mobile card variant of a coin row (used < 760px).
 */
const CoinCard = React.memo(function CoinCard({
  coin,
  currency,
  starred,
  onToggleStar,
  onOpen,
}) {
  const week = coin.price_change_percentage_7d_in_currency;
  const day = coin.price_change_percentage_24h_in_currency;

  return (
    <div
      className="coin-card"
      role="button"
      tabIndex={0}
      onClick={() => onOpen(coin.id)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen(coin.id);
        }
      }}
      aria-label={`${coin.name} — open details`}
    >
      <div className="card-head">
        <img src={coin.image} alt="" width="24" height="24" loading="lazy" className="coin-logo" />
        <span className="coin-name">{coin.name}</span>
        <span className="coin-symbol mono dim">{coin.symbol.toUpperCase()}</span>
        <WatchlistToggle
          starred={starred}
          onToggle={() => onToggleStar(coin.id)}
          symbol={coin.symbol}
        />
      </div>
      <div className="card-main">
        <span className="card-price mono">{formatPrice(coin.current_price, currency)}</span>
        <span
          className={`card-change mono pct ${percentClass(day)}`}
        >
          {formatPercent(day)}
        </span>
      </div>
      <div className="card-grid">
        <div>
          <span className="card-label">1h</span>
          <span
            className={`mono pct ${percentClass(coin.price_change_percentage_1h_in_currency)}`}
          >
            {formatPercent(coin.price_change_percentage_1h_in_currency)}
          </span>
        </div>
        <div>
          <span className="card-label">7d</span>
          <span className={`mono pct ${percentClass(week)}`}>{formatPercent(week)}</span>
        </div>
        <div>
          <span className="card-label">Mkt Cap</span>
          <span className="mono">{formatCompact(coin.market_cap, currency)}</span>
        </div>
        <div>
          <span className="card-label">Volume</span>
          <span className="mono">{formatCompact(coin.total_volume, currency)}</span>
        </div>
      </div>
      <div className="card-spark">
        <Sparkline data={coin.sparkline_in_7d?.price} up={week == null ? true : week >= 0} width={280} height={44} />
      </div>
    </div>
  );
});

export default CoinCard;
